/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Practice } from './practice';
import { AppointmentStatusEnum } from './appointmentStatusEnum';
import { TherapistProfileSerializerMinimal } from './therapistProfileSerializerMinimal';
import { SessionTypeEnum } from './sessionTypeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarFilterResponse { 
    readonly sessionTypes: Array<SessionTypeEnum>;
    readonly appointmentStatuses: Array<AppointmentStatusEnum>;
    readonly appointmentStatusDefault: Array<AppointmentStatusEnum>;
    organizations: Array<Practice>;
    therapists: Array<TherapistProfileSerializerMinimal>;
}
export const CalendarFilterResponse_sessionTypes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarFilterResponse_appointmentStatuses_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarFilterResponse_appointmentStatusDefault_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarFilterResponse_organizations_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarFilterResponse_therapists_Validators: ValidatorFn[] =
    [  Validators.required, ];


